// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"slider-horizontal-card-m__horizontal__3q8yK","content":"slider-horizontal-card-m__content__2BNVP","border":"slider-horizontal-card-m__border__r5qiP"};